import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "../api/index";

const ForgotPassword = ({ onGoBack }) => {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      await axios.post(`${API_URL}/reset/request`, { email });
      setMsg("Si el email existe, recibirás instrucciones para recuperar tu contraseña.");
    } catch (error) {
      setMsg("Ocurrió un error. Inténtalo de nuevo.");
    }
    setLoading(false);
  };

  return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl">
          <h2 className="text-2xl font-bold mb-6 text-center">¿Olvidaste tu contraseña?</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
                type="email"
                placeholder="Introduce tu email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                className="border rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
                type="submit"
                disabled={loading}
                className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-2 font-semibold transition disabled:bg-blue-300"
            >
              {loading ? "Enviando..." : "Enviar instrucciones"}
            </button>
          </form>
          {msg && (
              <div className="mt-6 text-center text-sm text-green-700 bg-green-100 rounded-xl p-3">
                {msg}
              </div>
          )}
          <button
              onClick={onGoBack}
              className="w-full mt-6 text-blue-600 hover:underline text-center"
          >
            Volver al login
          </button>
        </div>
      </div>
  );
};

export default ForgotPassword;